import React from 'react';
import TaskView from './taskView';

// La vue porte ses propres fiches : cet enrobage n'ajoutait qu'une grille.
function Task() {
  return <TaskView />;
}

export default Task;
